var daterangepicker = require('daterangepicker');
function init(element, options, cb) {
    if(cb) {
        return new daterangepicker(element, options, cb);
    }

    return new daterangepicker(element, options);
}

export default {
    init
}


// WEBPACK FOOTER //
// ./resources/assets/layout-novo/js/modulo/daterangerpicker.js